import {
  apiUrls,
  dataStorageKeywords,
  routeURL,
} from 'src/utils/properties.utils';
import {
  clearAllCookies,
  clearLocalStorage,
  getEncryptedLocalStorageData,
} from 'src/utils/dataStorageManagement.utils';
import { axiosInstance } from 'src/utils/axiosInstance.utils';
import Cookies from 'js-cookie';
import { getApiErrorMessage } from 'src/utils/errorHandler';

export const isLoggedIn = (): boolean => {
  const refreshToken = Cookies.get(dataStorageKeywords.REFRESH_TOKEN);
  return !!refreshToken;
};

export const getUserHighestRole = async (): Promise<string | null> => {
  try {
    const role = await getEncryptedLocalStorageData(
      dataStorageKeywords.HIGHEST_ROLE
    );
    return role || null;
  } catch (e) {
    return null;
  }
};

export const handleLogout = async (navigate: any, showSnackbar: any) => {
  try {
    const response = await axiosInstance.post(apiUrls.LOGOUT);

    clearAllCookies();
    clearLocalStorage();
    showSnackbar(response.data.message, 'success');
    navigate(routeURL.LOGIN);
  } catch (e) {
    const errorMessage = await getApiErrorMessage(e);
    showSnackbar(errorMessage, 'error');
  }
};

export const handleSessionExpiration = () => {
  clearAllCookies();
  clearLocalStorage();
  sessionStorage.setItem('sessionExpired', 'true');
  window.location.href = apiUrls.LOGIN;
};
